import React from "react";
import { ThunderboltOutlined, PlusOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { TokenBalance } from "../subscription.types";

interface TokensSectionProps {
  balance: TokenBalance;
  onBuy: () => void;
  unlimitedCredits?: boolean;
}

const TokensSection: React.FC<TokensSectionProps> = ({
  balance,
  onBuy,
  unlimitedCredits,
}) => {
  const { t } = useTranslation("subscription");
  const total = balance.balance + balance.usedThisPeriod;
  const usedPct = total > 0 ? Math.round((balance.usedThisPeriod / total) * 100) : 0;
  const remainingChars = balance.balance * balance.charsPerToken;

  const fmtChars = (n: number) =>
    n >= 1_000_000
      ? `${(n / 1_000_000).toFixed(1)}M`
      : n >= 1_000
        ? `${Math.round(n / 1000)}k`
        : `${n}`;

  return (
    <div className="sub-tokens">
      <div className="sub-tokens-head">
        <div>
          <h3 className="sub-billing-title">{t("tokensSection.title")}</h3>
          <p className="sub-tokens-note">
            {t("tokensSection.note", {
              chars: balance.charsPerToken.toLocaleString(),
            })}
          </p>
        </div>
        {!unlimitedCredits && (
          <button className="sub-btn sub-btn-primary" onClick={onBuy}>
            <PlusOutlined /> {t("tokensSection.buy")}
          </button>
        )}
      </div>

      <div className="sub-tokens-box">
        <div className="sub-token-balance">
          <span className="sub-token-ic">
            <ThunderboltOutlined />
          </span>
          <div>
            <div className="sub-token-count">
              {balance.balance.toLocaleString()}{" "}
              <span>{t("tokensSection.creditsLeft")}</span>
            </div>
            <div className="sub-token-sub">
              {t("tokensSection.charsOfTranslation", {
                chars: fmtChars(remainingChars),
              })}
            </div>
          </div>
        </div>

        {balance.usedThisPeriod > 0 ? (
          <div className="sub-token-meter">
            <div className="sub-token-meter-bar">
              <div
                className="sub-token-meter-fill"
                style={{ width: `${usedPct}%` }}
              />
            </div>
            <div className="sub-token-meter-labels">
              <span>
                {t("tokensSection.usedThisPeriod", {
                  value: balance.usedThisPeriod.toLocaleString(),
                })}
              </span>
              <span>
                {t("tokensSection.remaining", {
                  value: balance.balance.toLocaleString(),
                })}
              </span>
            </div>
          </div>
        ) : (
          <div className="sub-token-note">{t("tokensSection.autoSpendNote")}</div>
        )}
      </div>
    </div>
  );
};

export default TokensSection;
